<template>
    <el-drawer
        :title="`兑换商品`"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        :before-close="close">
        <div class="panel fx-g1">
            <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                <el-form-item label="地址">
                    <el-input v-model="form.address"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <span class="fx fx-center">
            <el-button type="primary" @click="sub()">保 存</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>

</style>


<script>


    export default {
        props: [
            "item",
        ],
        data() {
            return {
                show: false,
                needRefreshParent: false,
                form: {...this.item},
                showLoading: false,
            }
        },
        computed: {
        },
        watch: {
        },
        methods: {
            sub() {
                this.$ajaxPost("/exchangeRecord/save", {
                    exchangeRecord: this.form
                }, (data) => {
                    this.$emit("submit");
                })
            },
            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {
                    this.$emit("close");
                }
            },
            handleLessonChoose(val) {
                this.choosedLesson = val;
            },
        },
        mounted() {
            this.show = true;
        },
        created() {
        }
    }
</script>
